import { useEffect } from 'react';

// Lightweight SEO meta without extra dependencies
const PageMeta = ({ title, description }) => {
  useEffect(() => {
    document.title = title ? `${title} | HypeCro` : 'HypeCro — GA4 AB Test Analytics';

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    if (description) meta.content = description;
  }, [title, description]);

  return null;
};

export default PageMeta;
